import clsx from 'clsx'
import { INotification } from '../types'
import styles from './Notification.module.scss'
import errorStyles from './ErrorNotification.module.scss'
import { Button } from '@/ui/Button'
import OfflineIcon from '../assets/offline_24.svg'

interface Props extends Partial<INotification> {
    clearNotification: () => void
}

export const ErrorNotification = ({
    title,
    message,
    className,
    type = 'default',
    size,
    clearNotification,
    errorDismissTitle = 'Done',
}: Props) => {
    return (
        <>
            <div className={errorStyles.backdrop} />

            <div className={clsx(styles.root, errorStyles.errorRoot, size && styles[size], styles[type], className)}>
                <div className={errorStyles.textContainer}>
                    <div className={errorStyles.headerRow}>
                        <span className={errorStyles.errorIcon}>
                            <OfflineIcon />
                        </span>
                        <div className={errorStyles.headerText}>{title}</div>
                    </div>
                    <div className={errorStyles.bodyText}>{message}</div>
                    <div className={errorStyles.buttonContainer}>
                        <Button rounded variant="secondary" onClick={clearNotification}>
                            {errorDismissTitle}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}
